import { ref, watch } from 'vue-demi';
import { priceplans } from '@/platform/config/constants';

export default ({ userContext, accountContext }) => {
  const ready = ref(false);

  /**
   * Bail watcher if window.pendo is not available (dev env)
   */
  if (window.pendo) {
    watch(
      [userContext.user, accountContext.account],
      ([user, account], prev) => {
        if (!(Array.isArray(prev) && user && account)) {
          return;
        }

        const [prevUser, prevAccount] = prev;

        const planId = Number(account.pricePlanId);
        const isPaying = !!(
          account.isPaid || [priceplans.FREE, priceplans.PERUSER_FREE].includes(planId)
        );

        const isTrial =
          !account.isPaid &&
          account.paymentStatus === 'trial' &&
          Number(account.trialDaysRemaining) > 0;

        const priceplanTrialDaysRemaining = Math.floor(
          (new Date(account.priceplanTrialData?.endDate).getTime() - Date.now()) /
            (1000 * 60 * 60 * 24),
        );

        const options = {
          visitor: {
            is_trial: isTrial,
            is_paying: isPaying,

            id: `${account.id}-${user.id}`,
            new_visitor_id: 'true',
            email: user['email-address'],
            full_name: `${user['first-name']} ${user['last-name']}`,
            site_owner: !!(user['site-owner'] && user.administrator),
            site_admin: !!(!user['site-owner'] && user.administrator),
            site_baseUrl: account.URL,
            in_owner_company: !!user['in-owner-company'],
            collaborator: user['user-type'] === 'collaborator',
            add_projects: !!user.permissions['can-add-projects'],
            manage_people_and_companies: !!user.permissions['can-manage-people'],
            manage_portfolios: !!(
              user.administrator &&
              (user['in-owner-company'] || user.permissions.canManagePortfolio)
            ),
            timezone: user.localization.timezone,
            manage_task_templates: !!user.permissions.canAccessPortfolio,
          },

          account: {
            plan_id: planId,
            is_trial: isTrial,
            is_paying: isPaying,

            id: account.id,
            name: `${account.name}: Projects`,
            subscription_plan: account.pricePlan,
            license_count:
              account.priceplanType === 'perUser'
                ? Number(account.paidForUsers)
                : Number(user.stats?.users?.count),
            start_date: account.datesignedup,
            industry: account.industryCategoryName,
            site_baseUrl: account.URL,
            sso_enabled: !!account.SSO?.enabled,
            server_region: account.awsRegion,
            shard_no: account.shardNo,
            first_payment_date: account.installationDateFirstPayment || '',
            strict_branding: account.strictBranding,
            allow_tw_brand: account.allowTeamworkProjectsBrand,
            is_installation_id_even: !(parseInt(account.id, 10) % 2),
            trial_plan_id: Number(account.priceplanTrialData?.id),
            trial_plan_days_remaining: priceplanTrialDaysRemaining || null,
          },

          events: {
            ready: () => {
              ready.value = true;
            },
          },
        };

        if (user.id === prevUser?.id && account.id === prevAccount?.id) {
          window.pendo.updateOptions(options);
        } else {
          window.pendo.initialize(options);
        }
      },
      {
        immediate: true,
      },
    );
  }

  return {
    ready,
  };
};
